import React, { useState, useEffect } from "react";
import SectionKelolaDuaField from "components/CrudUserSetup/SectionKelolaDuaField";
import ConfirmDialog from "../../../components/Feedback/ConfirmDialog";
import AlertDialog from "../../../components/Feedback/AlertDialog";

import {
  getAllSuppliers,
  createSupplier,
  updateSupplier,
  deleteSupplier,
} from "../../../services/supplierService";

const SupplierSetup = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const normalizeArray = (res) => {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.data?.data)) return res.data.data;
    return [];
  };

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const res = await getAllSuppliers();
        // mapping agar sesuai dengan komponen SectionKelolaDuaField
        const mapped = normalizeArray(res).map((s) => ({
          id: s.id,
          name: s.name,
          code: s.code_sp, // mapping code_sp → code
        }));
        setSuppliers(mapped);
      } catch (err) {
        console.error("Gagal memuat data supplier:", err);
      }
    };

    fetchSuppliers();
  }, []);

  const handleAddSupplier = async (value) => {
    try {
      const res = await createSupplier({
        name: value.name,
        codeSP: value.code, // kirim sesuai field API
      });
      const newItem = normalizeArray(res)[0] ?? res?.data ?? res;

      setSuppliers((prev) => [
        {
          id: newItem.id,
          name: newItem.name,
          code: value.code,
        },
        ...prev,
      ]);
      setAlertMessage("Supplier berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal menambah supplier:", err);
    }
  };

  const handleEditSupplier = async (item) => {
    try {
      const res = await updateSupplier(item.id, {
        name: item.name,
        codeSP: item.code,
      });

      // Jika respons sukses, update state langsung
      if (res?.status === 200 || res?.success) {
        setSuppliers((prev) =>
          prev.map((p) =>
            p.id === item.id ? { ...p, name: item.name, code: item.code } : p
          )
        );
      } else {
        console.error("Update gagal, respons dari server:", res);
      }
    } catch (err) {
      console.error("Gagal mengedit supplier:", err?.response?.data ?? err);
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedDeleteItem) return;

    try {
      await deleteSupplier(selectedDeleteItem.id);
      setSuppliers((prev) =>
        prev.filter((p) => p.id !== selectedDeleteItem.id)
      );
    } catch (err) {
      console.error("Gagal menghapus supplier:", err);
    } finally {
      setIsConfirmOpen(false);
      setSelectedDeleteItem(null);
    }
  };

  return (
    <div className="pt-10 pb-10 pl-64 pr-6">
      <h1 className="mb-6 text-2xl font-bold text-green-800">
        Manajemen Supplier
      </h1>

      <div className="w-full max-w-2xl">
        <SectionKelolaDuaField
          title="Supplier"
          data={suppliers}
          onAdd={handleAddSupplier}
          onEdit={handleEditSupplier}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setIsConfirmOpen(true);
          }}
          codeInputClass="flex-grow"
          codeMaxLength={null}
        />
      </div>
      <ConfirmDialog
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Hapus Supplier"
        message="Apakah Anda yakin ingin menghapus supplier ini?"
      />
      {isAlertOpen && (
        <AlertDialog
          isOpen={isAlertOpen}
          onClose={() => setIsAlertOpen(false)}
          title="Berhasil"
          message={alertMessage}
        />
      )}
    </div>
  );
};//

export default SupplierSetup;
